<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">Fraud prevention</h1>

        <section class="content-section">
            <p class="desc-text">XigCheck applies multiple marketplace integrity procedures designed to reduce fraudulent activity involving high-value goods and collectible products.</p>
            <p class="desc-text">Risk-control procedures may include:</p>
            <ul class="policy-list">
                <li>suspicious listing review</li>
                <li>duplicate image detection</li>
                <li>account behavior monitoring</li>
                <li>repeated counterfeit activity detection</li>
                <li>transaction anomaly review</li>
                <li>high-risk seller monitoring</li>
                <li>restricted category review procedures</li>
            </ul>
            <p class="desc-text">Products or accounts identified as potentially fraudulent may be temporarily restricted, escalated for manual review, or removed from marketplace visibility.</p>
            <p class="desc-text">XigCheck may also coordinate with platform trust and safety systems to support marketplace integrity review procedures where appropriate.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckFraudPrevention'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
